module.exports = __webpack_public_path__ + "static/media/ActiveFilter.e4fdfa46.svg";